import { render, staticRenderFns } from "./ImportLocations.vue?vue&type=template&id=2413f26f"
import script from "./ImportLocations.vue?vue&type=script&lang=js"
export * from "./ImportLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports